const getEnv = () => {
  if (process.env.REACT_APP_CUSTOM_ENV) {
    return process.env.REACT_APP_CUSTOM_ENV
  }

  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV
  }

  return 'qa'
}

export default {
  enableDevTools: Boolean(process.env.REACT_APP_DEV_TOOLS_ENABLED),
  env: getEnv(),
}
